import { render, staticRenderFns } from "./EditContract.vue?vue&type=template&id=3c688848&scoped=true"
import script from "./EditContract.vue?vue&type=script&lang=js"
export * from "./EditContract.vue?vue&type=script&lang=js"
import style0 from "./EditContract.vue?vue&type=style&index=0&id=3c688848&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c688848",
  null
  
)

export default component.exports